import React, {useCallback, useContext, useMemo, useState} from 'react';
import {useHistory, useRouteMatch} from 'react-router-dom';
import {Button, Collapse, Nav, Navbar, NavbarBrand, NavbarToggler,} from 'reactstrap';
import styled from 'styled-components';
import {ModalContext, ThemeContext} from '../../apiContexts';
import SearchAutocomplete from '../../components/searchAutocomplete';
import ModalEnum from '../modals/modalEnum';

const initSearchData = {
    emptyLabel: 'Nada encontrado!',
    minLength: 2,
    align: 'right',
    caseSensitive: false,
    ignoreDiacritics: false,
    labelKey: 'name',
    filterBy: ['uniqueId', 'name', 'groupName'],
    options: [],
    renderMenuItemChildren: ({uniqueId, name}) => (
        <div>
            {name}
            <div>
                <small>Id: {uniqueId}</small>
            </div>
        </div>
    ),
};

const StyledNavbar = styled(Navbar)``;

const NewReportStyled = styled(Button)`
  color: ${(props) => props.theme} !important;

  &:hover,
  &:active {
    > span {
      color: white;
    }
  }
`;

const NavBar = (props) => {

    const {devices} = props;
    const [isOpen, setIsOpen] = useState(false);
    const theme = useContext(ThemeContext);
    const {openModal} = useContext(ModalContext);
    const history = useHistory();
    const match = useRouteMatch();

    const toggle = () => setIsOpen(!isOpen);

    const searchDevice = useCallback(
        (data) => {
            if (data.length) {
                const {id} = data[0];
                history.push(`${match.url}/events/devices/${id}`);
            }
        },
        [match.url],
    );

    const options = useMemo(
        () =>
            devices.list.map(({id, uniqueId, name, groupName}) => ({
                id,
                uniqueId: uniqueId,
                name,
                groupName: groupName ? groupName : '',
            })),
        [devices.list]
    );

    return (
        <StyledNavbar
            color="white"
            light
            expand="md"
            className="shadow px-5"
            theme={theme}
        >
            <NavbarBrand href="/">
                <Logo src={`${process.env.PUBLIC_URL}/images/logo.png`}/>
            </NavbarBrand>
            <NavbarToggler onClick={toggle}/>
            <Collapse isOpen={isOpen} navbar>
                <Nav className="ml-auto" navbar>
                    <SearchAutocomplete
                        className="mr-4"
                        id="searchDevice"
                        bsSize="large"
                        placeholder="Digite para pesquisar"
                        onChange={searchDevice}
                        {...initSearchData}
                        options={options}
                    />

                    <NewReportStyled
                        theme={theme}
                        outline
                        className="custom-shadow custom-border btn-theme"
                        size="lg"
                        onClick={() => openModal(ModalEnum.NEW_REPORT)}
                    >
            <span>
              Novo Relatorio <span className="fal fa-plus"/>
            </span>
                    </NewReportStyled>
                </Nav>
            </Collapse>
        </StyledNavbar>
    );
};

const Logo = ({src}) => (
    <div id="logo">{src && <img alt="logo" src={src} height="58"/>}</div>
);

export default NavBar;
